import { useEffect, useState } from "react";
import Input from "./form/input";
import { useNavigate, useOutletContext } from "react-router-dom";
import Swal from "sweetalert2";

const ForgetPass = () => {

    const [email, setEmail] = useState("");

    // functions from App component
    // to transit values of JWT and errors to App component

    const { setAlertClassName } = useOutletContext();
    const { setAlertMessage } = useOutletContext();


    const navigate = useNavigate();

    // delete all the previous errors
    useEffect(() => {
        setAlertClassName("d-none"); // hide alert if it was
        setAlertMessage("");
    }, [setAlertClassName, setAlertMessage]);


    const handleSubmit = (event) => {
        event.preventDefault();

        // Validation 
        // check if the fields are not empty
        if (email === "") {
            setAlertClassName("alert-danger");
            setAlertMessage("All fields must be filled!")
            return
        }

        //  create the request payload
        //  email and password are from state
        let payload = {
            email: email,
        }

        const requestOptions = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            withCredentials: true,
            body: JSON.stringify(payload),
        }

        // make a request
        fetch(`${process.env.REACT_APP_BACKEND}/api/forget-password`, requestOptions)
            // convert response to json 
            .then((response) => response.json())
            .then((data) => {
                // if there IS an error 
                if (data.error) {
                    setAlertClassName("alert-danger"); // show error class
                    setAlertMessage(data.message);
                } else { // if there is NO error
                    setAlertClassName("d-none"); // hide alert if it was
                    setAlertMessage("");
                    Swal.fire({ // message to confirm email
                        title: 'Check your email!',
                        text: 'Link has been sent to your email',
                        icon: 'info',
                        confirmButtonText: 'OK'
                    })
                    navigate("/"); // redirect to home page
                }
            })
            // if there is an unexpected error
            .catch(error => {
                setAlertClassName("alert-danger");
                setAlertMessage(error);
            })
    }

    return (
        <div className="col-md-6 offset-md-3">
            <h2>Reset password</h2>
            <hr />
            <form onSubmit={handleSubmit}>
                <Input
                    title="Enter your email and we will send you a link to reset your password"
                    type="email"
                    className="form-control"
                    name="email"
                    autoComplete="email-new"
                    onChange={(event) => setEmail(event.target.value)}
                />
                <hr />
                <input
                    type="submit"
                    className="btn btn-primary"
                    value="Reset"
                />
            </form>
        </div>
    )
}

export default ForgetPass;